import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  TotpEnrollmentService,
  // eslint-disable-next-line camelcase
  type WealthlaneDtos_Totps_TotpEnrollmentResponseDto,
} from '../../services/wealthlane-identity-services';

const usePostEnrollmentVerify = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  setQrCodeVerifyResponse: ({
    recovery,
    qrCodeVerify,
  }: {
    recovery?: string[] | null;
    qrCodeVerify: boolean;
  }) => void
): UseMutationResult<
  // eslint-disable-next-line camelcase
  WealthlaneDtos_Totps_TotpEnrollmentResponseDto | undefined,
  unknown,
  any,
  unknown
> => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        TotpEnrollmentService.postApiIdentityApiTotpEnrollmentVerify(payload)
      );
    },
    {
      onSuccess: async (
        // eslint-disable-next-line camelcase
        response: WealthlaneDtos_Totps_TotpEnrollmentResponseDto | undefined
      ) => {
        if (response != null) {
          toast.success(<ToastComponent label='Success' message={`Code Verified.`} />);
          setQrCodeVerifyResponse({ recovery: response.recoveryCodes, qrCodeVerify: true });
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostEnrollmentVerify;
